"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEN_FUNC = exports.WEN_FUNC_TRIGGER = void 0;
var WEN_FUNC_TRIGGER;
(function (WEN_FUNC_TRIGGER) {
    WEN_FUNC_TRIGGER["onProposalUpdated"] = "onproposalupdated";
    WEN_FUNC_TRIGGER["awardTrigger"] = "awardtrigger";
    WEN_FUNC_TRIGGER["collectionWrite"] = "collectionwrite";
    WEN_FUNC_TRIGGER["onTokenStatusUpdate"] = "ontokenstatusupdate";
    WEN_FUNC_TRIGGER["onTokenTradeOrderWrite"] = "ontokentradeorderwrite";
    WEN_FUNC_TRIGGER["onTokenPurchaseCreated"] = "ontokenpurchasecreated";
    WEN_FUNC_TRIGGER["milestoneTransactionWrite"] = "milestonetransactionwrite";
    WEN_FUNC_TRIGGER["nftWrite"] = "nftwrite";
    WEN_FUNC_TRIGGER["transactionWrite"] = "transactionwrite";
    WEN_FUNC_TRIGGER["mnemonicWrite"] = "mnemonicwrite";
    WEN_FUNC_TRIGGER["collectionStatsUpdate"] = "collectionstatsupdate";
    WEN_FUNC_TRIGGER["algolia"] = "algolia";
    WEN_FUNC_TRIGGER["resizeImg"] = "resizeimg";
})(WEN_FUNC_TRIGGER = exports.WEN_FUNC_TRIGGER || (exports.WEN_FUNC_TRIGGER = {}));
var WEN_FUNC;
(function (WEN_FUNC) {
    // Member functions.
    WEN_FUNC["createMember"] = "cmembernotexists";
    WEN_FUNC["updateMember"] = "umember";
    // Space functions.
    WEN_FUNC["createSpace"] = "cspace";
    WEN_FUNC["updateSpace"] = "uspace";
    WEN_FUNC["joinSpace"] = "joinspace";
    WEN_FUNC["leaveSpace"] = "leavespace";
    WEN_FUNC["blockMemberSpace"] = "blockmemberspace";
    WEN_FUNC["unblockMemberSpace"] = "unblockmemberspace";
    WEN_FUNC["acceptMemberSpace"] = "acceptmemberspace";
    WEN_FUNC["declineMemberSpace"] = "declinememberspace";
    WEN_FUNC["addGuardianSpace"] = "addguardianspace";
    WEN_FUNC["removeGuardianSpace"] = "removeguardianspace";
    WEN_FUNC["claimSpace"] = "claimspace";
    // Award functions
    WEN_FUNC["createAward"] = "caward";
    WEN_FUNC["fundAward"] = "fundaward";
    WEN_FUNC["rejectAward"] = "raward";
    WEN_FUNC["addOwnerAward"] = "addowneraward";
    WEN_FUNC["participateAward"] = "participateaward";
    WEN_FUNC["approveParticipantAward"] = "aparticipantaward";
    WEN_FUNC["cancelAward"] = "cancelaward";
    WEN_FUNC["createProposal"] = "cproposal";
    WEN_FUNC["approveProposal"] = "aproposal";
    WEN_FUNC["rejectProposal"] = "rproposal";
    WEN_FUNC["voteOnProposal"] = "voteonproposal";
    // Collection functions.
    WEN_FUNC["createCollection"] = "ccollection";
    WEN_FUNC["updateCollection"] = "ucollection";
    WEN_FUNC["approveCollection"] = "approvecollection";
    WEN_FUNC["rejectCollection"] = "rejectcollection";
    WEN_FUNC["mintCollection"] = "mintcollection";
    // NFT functions.
    WEN_FUNC["createNft"] = "cnft";
    WEN_FUNC["createBatchNft"] = "cbatchnft";
    WEN_FUNC["setForSaleNft"] = "setforsalenft";
    WEN_FUNC["withdrawNft"] = "withdrawnft";
    WEN_FUNC["depositNft"] = "depositnft";
    WEN_FUNC["updateUnsoldNft"] = "updateunsoldnft";
    WEN_FUNC["stakeNft"] = "stakenft";
    // ORDER functions.
    WEN_FUNC["orderNft"] = "ordernft";
    WEN_FUNC["openBid"] = "openbid";
    WEN_FUNC["validateAddress"] = "validateaddress";
    // TOKEN functions
    WEN_FUNC["createToken"] = "ctoken";
    WEN_FUNC["updateToken"] = "utoken";
    WEN_FUNC["setTokenAvailableForSale"] = "settokenavailableforsale";
    WEN_FUNC["cancelPublicSale"] = "cancelpublicsale";
    WEN_FUNC["orderToken"] = "ordertoken";
    WEN_FUNC["creditToken"] = "credittoken";
    WEN_FUNC["airdropToken"] = "airdroptoken";
    WEN_FUNC["claimAirdroppedToken"] = "claimairdroppedtoken";
    WEN_FUNC["tradeToken"] = "tradetoken";
    WEN_FUNC["cancelTradeOrder"] = "canceltradeorder";
    WEN_FUNC["mintTokenOrder"] = "minttokenorder";
    WEN_FUNC["claimMintedTokenOrder"] = "claimmintedtokenorder";
    WEN_FUNC["airdropMintedToken"] = "airdropmintedtoken";
    WEN_FUNC["enableTokenTrading"] = "enabletokentrading";
    WEN_FUNC["importMintedToken"] = "importmintedtoken";
    WEN_FUNC["creditUnrefundable"] = "creditunrefundable";
    WEN_FUNC["depositStake"] = "depositstake";
    WEN_FUNC["voteController"] = "votecontroller";
    WEN_FUNC["rankController"] = "rankcontroller";
    WEN_FUNC["stakeReward"] = "stakereward";
    WEN_FUNC["removeStakeReward"] = "removestakereward";
    WEN_FUNC["generateCustomToken"] = "generatecustomtoken";
    WEN_FUNC["api"] = "api";
    WEN_FUNC["uploadFile"] = "uploadfile";
})(WEN_FUNC = exports.WEN_FUNC || (exports.WEN_FUNC = {}));
